import type { FaireProductEntity } from "../../entity_types/product";

export const p_4qtb63gdpd: FaireProductEntity = {
  token: "p_4qtb63gdpd",
  type: "product",
  name: 'Slender Watering Can - 4 Asst - 13"L',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/8e2160b6cf3cac556995b069bb74fe8b7b3e6ef01d088ed220bd73deba012469.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b3e5572195ff30de9daf0af5838abdfe6d09ec92e71923c81ebe747615d4dc09.png",
    "https://cdn.faire.com/fastly/818670379f0401b6137e4a90b694915b75e4d75b54dfe1f35ddff990f06d1e38.jpeg",
    "https://cdn.faire.com/fastly/d78d46e099a954c45750e9323a76b2a49fef4d52a4de2961e5afe93b5c957683.jpeg",
    "https://cdn.faire.com/fastly/2258532320907aa30f01de394c16881df37be3d43451c221a36b836394cd977f.jpeg",
    "https://cdn.faire.com/fastly/2fb24e606caad2d21a71a78bacca227e5bb0a4d41ca1607abbb1cdc412940f98.jpeg",
    "https://cdn.faire.com/fastly/2c0b0659f84ef93c0aca20274383809ae900e01299433b31c5b97227c8c58714.jpeg",
  ],
  priceDollars: 12.5,
  description:
    "Add a chic, art-deco touch to your gardening accessories with these colorful Slender Watering Cans. Available in 4 assorted primary colors, their sleek, streamlined shape and easy-pour spout make them as functional as they are fashionable — a stylish complement to any garden, indoors or out. Each assortment contains 4 different colors. Price per item.",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:10.603Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
